import { z } from 'zod';
import { dataOraSchema, idSchema } from '../common';
import { CATALOGO_EXPORT } from './catalogo';
import { DatasetExport, FormatoExport, StatoEsportazione } from './enums';

/** Tetto dell'export avanzato: oltre, si restringono i filtri. */
export const EXPORT_AVANZATO_MAX_ROWS = 10_000;

/** Giorni per cui un file prodotto resta scaricabile. */
export const GIORNI_VALIDITA_EXPORT = 7;

/**
 * Richiesta di export avanzato. `filtri` è la query della lista di partenza,
 * senza paginazione: l'API la valida con lo schema di quella lista e sceglie le
 * righe con lo stesso service, così il file contiene esattamente ciò che la
 * lista mostrerebbe.
 */
export const richiestaExportSchema = z
  .object({
    dataset: DatasetExport,
    filtri: z.record(z.string(), z.unknown()).default({}),
    colonne: z.array(z.string()).min(1, 'Scegli almeno una colonna'),
    fogli: z.array(z.string()).default([]),
    formato: FormatoExport,
  })
  .superRefine((r, ctx) => {
    const catalogo = CATALOGO_EXPORT[r.dataset];
    const colonne = new Set(catalogo.colonne.map((c) => c.chiave));
    const fogli = new Set(catalogo.fogli.map((f) => f.chiave));
    for (const c of r.colonne) {
      if (!colonne.has(c)) {
        ctx.addIssue({ code: 'custom', path: ['colonne'], message: `Colonna sconosciuta: ${c}` });
      }
    }
    for (const f of r.fogli) {
      if (!fogli.has(f)) {
        ctx.addIssue({ code: 'custom', path: ['fogli'], message: `Foglio sconosciuto: ${f}` });
      }
    }
  });
export type RichiestaExport = z.infer<typeof richiestaExportSchema>;

/** Un export dell'utente, come lo mostra la pagina «I miei export». */
export const esportazioneSchema = z.object({
  id: idSchema,
  dataset: DatasetExport,
  formato: FormatoExport,
  stato: StatoEsportazione,
  righe: z.number().int().nullable(),
  fogli: z.number().int().nullable(),
  /** Quanti filtri erano attivi: il dettaglio resta nel registro attività. */
  filtriAttivi: z.number().int(),
  errore: z.string().nullable(),
  creatoIl: dataOraSchema,
  completatoIl: dataOraSchema.nullable(),
  scadeIl: dataOraSchema.nullable(),
});
export type Esportazione = z.infer<typeof esportazioneSchema>;

/** URL firmato, breve, verso il file pronto. */
export const downloadExportSchema = z.object({ url: z.string() });
export type DownloadExport = z.infer<typeof downloadExportSchema>;
